<template>
    <div>
		<!-- Alerta do cliente --> 
        <div class="modal fade" id="mdconteudoalertacliente" tabindex="-1">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-exclamation-triangle" style="font-size: 16px; margin-top: 4px; margin-right: 8px"></i><h4 class="modal-title" style="font-size: 16px;">Exibição do alerta!</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row"> 
                            <div class="col-md-12 text-center">
                                <i class="fa fa-exclamation-triangle" style="font-size: 60px; color: #f82b54;"></i>                                
                            </div>
                            <div class="col-md-12 text-center">
                                <h6 style="margin-top: 15px; font-size: 14px; font-weight: bold; color: #f82b54;">Atenção!</h6>
                            </div>                            
                            <div class="col-lg-12">
                                <pre class="dv-conteudo-alerta">{{ conteudovisualizar }}</pre>
                            </div>                 
                            <div class="col-12 text-center" style="margin-top: 15px; margin-bottom: 15px;">
                                <button type="button" class="btn btn-secondary btn-sm btn-red" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
                            </div>                            
                        </div>
                    </div>                                                  
                </div>
            </div>
        </div>                                   
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpconteudoalertacliente',
    props:[     
                'idcliente'
          ],
    data: function() {
        return {
            nomeclientevisualizar   : '',
            conteudovisualizar      : ''
        };
    },
    methods: {
        mtdlerconteudoalerta(){
            var vself       = this;
            let loader      = this.$loading.show();
            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'conteudoalerta'},
                {parametro: 'idcliente',    valor : vself.idcliente}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
            retorno.then(function (response) {
                vself.nomeclientevisualizar = response.data[0].nome;
                vself.conteudovisualizar    = response.data[0].conteudoalerta;                
                loader.hide();
            }).catch(function (response) {
                vself.nomeclientevisualizar = '';
                vself.conteudovisualizar    = '';                                
                loader.hide();
            });
        }
    },
    mounted: function() {
        let vself = this;
        vself.idcliente = null;
        $("#mdconteudoalertacliente").on('shown.bs.modal', function(){
            if (vself.idcliente !== null){
                vself.mtdlerconteudoalerta();
            }
        });
        $("#mdconteudoalertacliente").on('hide.bs.modal', function(){
            vself.nomeclientevisualizar = '';
            vself.conteudovisualizar    = '';
            vself.idcliente             = null;
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
	#mdconteudoalertacliente{
		z-index: 2003!important;
	}
    .dv-conteudo-alerta{
        font-family: "Nunito";
        margin-top: 10px;
        color: #666;
        font-size: 12px;
        text-align: justify;
        font-weight: bold;
    }
</style>